"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var queue_1 = require("rxjs/scheduler/queue");
var noop_1 = require("rxjs/util/noop");
var accounting_model_1 = require("./controls/accounting/accounting.model");
var money_model_1 = require("./controls/money/money.model");
var utilities_1 = require("./utilities");
var LOGGER = utilities_1.createLogger('accounting-state');
var ERROR_LOGGER = function (e) { return LOGGER.error(e); };
var ɵ0 = ERROR_LOGGER;
exports.ɵ0 = ɵ0;
/**
 * Can be used for money and accounting controls
 */
var CurrencyControlState = /** @class */ (function () {
    function CurrencyControlState(store) {
        this.store = store;
        /**
         * can be undefined only before initialization
         */
        this.actualState = new BehaviorSubject_1.BehaviorSubject(undefined);
        this.inheritance$ = new BehaviorSubject_1.BehaviorSubject(undefined);
        this.rateReadOnly$ = new BehaviorSubject_1.BehaviorSubject(undefined);
    }
    // region action
    CurrencyControlState.prototype.setAccounting = function (accounting) {
        var _this = this;
        if (lodash_1.isNil(accounting)) {
            skynet_store_currencies_api_1.getDefaultCurrency(this.store)
                .pipe(operators_1.first(), operators_1.tap(function (defaultCurrency) {
                _this.actualState.next({
                    rateByDate: 1,
                    accounting: new accounting_model_1.AccountingModel(1, new money_model_1.MoneyModel(undefined, defaultCurrency.id), utilities_1.todayUTC()),
                });
            }))
                .subscribe(noop_1.noop, ERROR_LOGGER);
        }
        else if (lodash_1.isNil(accounting.accountingDate) ||
            lodash_1.isNil(accounting.originalMoney.currencyId)) {
            this.actualState.next({
                rateByDate: undefined,
                accounting: accounting,
            });
        }
        else {
            this.rateByDate(accounting.originalMoney.currencyId, accounting.accountingDate)
                .pipe(operators_1.first(), operators_1.tap(function (rate) {
                _this.actualState.next({
                    rateByDate: rate,
                    accounting: accounting,
                });
            }))
                .subscribe(noop_1.noop, ERROR_LOGGER);
        }
    };
    CurrencyControlState.prototype.setMoney = function (money) {
        var _this = this;
        if (money_model_1.isMoneyNil(money)) {
            skynet_store_currencies_api_1.getDefaultCurrency(this.store)
                .pipe(operators_1.map(function (defaultCurrency) {
                return new money_model_1.MoneyModel(undefined, defaultCurrency.id);
            }))
                .subscribe(function (defaultMoney) {
                return _this.actualState.next({
                    rateByDate: undefined,
                    accounting: new accounting_model_1.AccountingModel(undefined, defaultMoney, undefined),
                });
            }, ERROR_LOGGER);
        }
        else {
            this.actualState.next({
                rateByDate: undefined,
                accounting: new accounting_model_1.AccountingModel(undefined, money, undefined),
            });
        }
    };
    CurrencyControlState.prototype.updateRate = function (rate) {
        var _this = this;
        this.actualState
            .pipe(operators_1.first(skynet_store_utilities_1.notNil), operators_1.tap(function (actualState) {
            _this.actualState.next(__assign({}, actualState, { accounting: new accounting_model_1.AccountingModel(rate, new money_model_1.MoneyModel(actualState.accounting.originalMoney.amount, actualState.accounting.originalMoney.currencyId), actualState.accounting.accountingDate) }));
        }))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.updateAmount = function (amount) {
        var _this = this;
        this.actualState
            .pipe(operators_1.first(skynet_store_utilities_1.notNil), operators_1.tap(function (actualState) {
            _this.actualState.next(__assign({}, actualState, { accounting: new accounting_model_1.AccountingModel(actualState.accounting.rateToDefault, new money_model_1.MoneyModel(amount, actualState.accounting.originalMoney.currencyId), actualState.accounting.accountingDate) }));
        }))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.updateCurrency = function (currencyId) {
        var _this = this;
        combineLatest_1.combineLatest(this.actualState.pipe(operators_1.filter(skynet_store_utilities_1.notNil)), skynet_store_currencies_api_1.getDefaultCurrency(this.store))
            .pipe(operators_1.first(), operators_1.switchMap(function (_a) {
            var state = _a[0], defaultCurrency = _a[1];
            if (defaultCurrency.id === currencyId) {
                _this.actualState.next({
                    rateByDate: 1,
                    accounting: new accounting_model_1.AccountingModel(1, new money_model_1.MoneyModel(state.accounting.originalMoney.amount, defaultCurrency.id), utilities_1.todayUTC()),
                });
                return of_1.of();
            }
            else if (lodash_1.isNil(state.accounting.accountingDate)) {
                // It is money
                _this.actualState.next({
                    rateByDate: 1,
                    accounting: new accounting_model_1.AccountingModel(1, new money_model_1.MoneyModel(state.accounting.originalMoney.amount, currencyId), state.accounting.accountingDate),
                });
                return of_1.of();
            }
            else {
                return _this.rateByDate(currencyId, state.accounting.accountingDate).pipe(operators_1.tap(function (rate) {
                    _this.actualState.next({
                        rateByDate: rate,
                        accounting: new accounting_model_1.AccountingModel(rate, new money_model_1.MoneyModel(state.accounting.originalMoney.amount, currencyId), state.accounting.accountingDate),
                    });
                }), operators_1.first());
            }
        }))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.updateDate = function (date) {
        var _this = this;
        this.actualState
            .pipe(operators_1.first(skynet_store_utilities_1.notNil), operators_1.switchMap(function (state) {
            if (lodash_1.isNil(state.accounting.originalMoney.currencyId)) {
                throw new Error("Currency Id can't be " + state.accounting.originalMoney.currencyId);
            }
            return combineLatest_1.combineLatest(_this.rateByDate(state.accounting.originalMoney.currencyId, date).pipe(operators_1.filter(skynet_store_utilities_1.notNil)), _this.rateReadOnly$.pipe(operators_1.first(skynet_store_utilities_1.notNil))).pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.tap(function (_a) {
                var rateByDate = _a[0], rateReadOnly = _a[1];
                _this.actualState.next(__assign({}, state, { rateByDate: rateByDate, accounting: new accounting_model_1.AccountingModel(rateReadOnly
                        ? rateByDate
                        : state.accounting.rateToDefault, new money_model_1.MoneyModel(state.accounting.originalMoney.amount, state.accounting.originalMoney.currencyId), date) }));
            }), operators_1.first());
        }))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.updateRateReadOnly = function (rateReadOnly) {
        this.rateReadOnly$.next(rateReadOnly);
    };
    CurrencyControlState.prototype.reset = function () {
        var _this = this;
        this.actualState.pipe(operators_1.first(skynet_store_utilities_1.notNil)).subscribe(function (state) {
            if (state.rateByDate === state.accounting.rateToDefault) {
                return;
            }
            _this.actualState.next(__assign({}, state, { accounting: new accounting_model_1.AccountingModel(state.rateByDate, state.accounting.originalMoney, state.accounting.accountingDate) }));
        }, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.inheritFrom = function (parent) {
        var _this = this;
        if (accounting_model_1.isEmptyAccounting(parent)) {
            return;
        }
        this.inheritance$
            .pipe(operators_1.switchMap(function (inheritance) {
            if (skynet_store_utilities_1.notNil(inheritance)) {
                return combineLatest_1.combineLatest(_this.actualState.pipe(operators_1.first(skynet_store_utilities_1.notNil)), _this.rateReadOnly$.pipe(operators_1.first(skynet_store_utilities_1.notNil))).pipe(operators_1.switchMap(function (_a) {
                    var fullState = _a[0], rateReadOnly = _a[1];
                    var accounting = inherit(rateReadOnly, fullState.accounting, parent);
                    return _this.rateByDate(accounting.originalMoney.currencyId, accounting.accountingDate).pipe(operators_1.observeOn(queue_1.queue), operators_1.tap(function (rateByDate) {
                        if (accounting.rateToDefault === 1 &&
                            !rateReadOnly &&
                            rateByDate !==
                                accounting.rateToDefault) {
                            accounting.rateToDefault = rateByDate;
                        }
                        _this.actualState.next({
                            rateByDate: rateByDate,
                            accounting: accounting,
                        });
                    }));
                }));
            }
            else {
                _this.inheritance$.next({
                    parent: parent,
                    enabled: false,
                });
                return of_1.of();
            }
        }), operators_1.take(1))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    CurrencyControlState.prototype.enableInheritance = function () {
        var _this = this;
        combineLatest_1.combineLatest(this.actualState.pipe(operators_1.first(skynet_store_utilities_1.notNil)), this.rateReadOnly$.pipe(operators_1.first(skynet_store_utilities_1.notNil)), this.inheritance$.pipe(operators_1.first(skynet_store_utilities_1.notNil)))
            .pipe(operators_1.first(), operators_1.switchMap(function (_a) {
            var fullState = _a[0], rateReadOnly = _a[1], inheritance = _a[2];
            var accounting = inherit(rateReadOnly, fullState.accounting, inheritance.parent);
            return _this.rateByDate(accounting.originalMoney.currencyId, accounting.accountingDate).pipe(operators_1.observeOn(queue_1.queue), operators_1.tap(function (rateByDate) {
                if (accounting.rateToDefault === 1 &&
                    !rateReadOnly &&
                    rateByDate !== accounting.rateToDefault) {
                    accounting.rateToDefault = rateByDate;
                }
                _this.actualState.next({
                    rateByDate: rateByDate,
                    accounting: accounting,
                });
                _this.inheritance$.next({
                    parent: inheritance.parent,
                    enabled: true,
                });
            }));
        }))
            .subscribe(noop_1.noop, ERROR_LOGGER);
    };
    // endregion
    // region selectors
    CurrencyControlState.prototype.getAccounting = function () {
        return this.actualState.pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.map(function (s) { return s.accounting; }), operators_1.distinctUntilChanged(function (f, s) { return accounting_model_1.compareAccounting(f, s); }));
    };
    CurrencyControlState.prototype.getMoney = function () {
        return this.actualState.pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.map(function (s) { return s.accounting.originalMoney; }), operators_1.distinctUntilChanged(function (f, s) { return money_model_1.compareMoney(f, s); }));
    };
    CurrencyControlState.prototype.getCurrentState = function () {
        return this.actualState.pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.map(function (state) { return (__assign({}, state, { isCustom: state.rateByDate !== state.accounting.rateToDefault })); }));
    };
    CurrencyControlState.prototype.getIsCustom = function () {
        return this.getCurrentState().pipe(operators_1.map(function (state) { return state.isCustom; }), operators_1.distinctUntilChanged());
    };
    // endregion
    CurrencyControlState.prototype.rateByDate = function (currencyId, date) {
        return skynet_store_currencies_api_1.currencyRateStoreManager
            .selectOne(this.store, skynet_store_currencies_api_1.keyExtractor({
            timestamp: date.getTime(),
            currencyId: currencyId,
        }))
            .pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.first(), operators_1.map(function (rate) { return rate.rate; }));
    };
    return CurrencyControlState;
}());
exports.CurrencyControlState = CurrencyControlState;
function inherit(rateReadOnly, accounting, parent) {
    if (rateReadOnly) {
        return new accounting_model_1.AccountingModel(parent.rateToDefault, new money_model_1.MoneyModel(accounting.originalMoney.amount, parent.originalMoney.currencyId), parent.accountingDate);
    }
    else {
        return new accounting_model_1.AccountingModel(accounting.rateToDefault, new money_model_1.MoneyModel(accounting.originalMoney.amount, parent.originalMoney.currencyId), parent.accountingDate);
    }
}
//# sourceMappingURL=currency-control.state.js.map